import { useEffect } from 'react';
import { useLocation, useParams, useSearchParams } from 'react-router';

const PageTitle = ({ title }) => {
  const [searchParams, setSearchParams] = useSearchParams();
  const location = useLocation();
  const params = useParams();

  /**
   * Use the route location path and params to set the document title.
   * If no location path or params match expected values, show the default title
   */
  const getPageTitle = () => {
    // split the path by '/' to get the path segments
    // remove the first item which is an empty string
    const path = location.pathname.split('/');
    path.shift();

    const mainPath = path[0];

    // console.log('location', location);
    // console.log('params', params);
    // console.log('searchParams', searchParams.get('type'));

    switch (mainPath) {
      /**
       * Locations
       */
      case 'locations': {
        const id = searchParams.get('locationId');
        const type = searchParams.get('type');
        const create = type === 'new';
        const modify = !create && id !== null;

        if (create || modify) {
          return create
            ? 'New Location'
            : 'View Location';
        }

        return title;
      }

      /**
       * Individual Location
       */
      case 'location': {
        if (path[2] === 'profile' && path[3] === 'player') {
          return `${title} - Player`;
        }

        return title;
      }

      /**
       * When no matches are found for the path,
       * return the title as is.
       */
      default:
        return title;
    }
  };

  useEffect(() => {
    const pageTitle = getPageTitle(title, location, params);
    // console.log('Title:', pageTitle);

    document.title = pageTitle;
  }, [location, title]);

  return null;
};

export default PageTitle;
